import React from 'react'
import Loading from '../Loading'
import Error from '../Error'
import PropTypes from 'prop-types'
import useData from '../../hooks/useData'
import Sprite from '../Svg/states/Sprite'
import Svg from '../Svg/states'
import { useDefaultImg, DEFAULT_CANDIDATE_IMAGE } from '../../util'
import { THOSE_WHOMST_HAVE_PICS } from '../../config'

const PresidentialPrimaryNational = ({ url, interval, party }) => {
  const data = useData(url, interval)
  if (data === undefined) {
    return <Loading />
  } else if (typeof data !== 'object') {
    return <Error err={data} />
  }

  return (
    <div className="section section-borderBottom">
      <div className="presidentialPrimaryDelegates">
        <DelegateRow party={party} results={data.results[0]} meta={data.meta} />
      </div>
    </div>
  )
}

const DelegateRow = ({ results, party, meta }) => {
  return (
    <div className="delegate-count">
      <div className="results-legend">
        <h3 className="results-header">
          {`Overview of ${party} Delegate Count Results`}
        </h3>
        <div className="results-key">
          {results.total_delegates_needed.toLocaleString('en-US')} to win
        </div>
      </div>
      <div className="results_source">
        Data Source: {meta.election_data_source === 'mn_oss' ? 'MN SOS' : 'AP'}
      </div>
      <div className="row row-candidate row-wrap" data-party={results.party}>
        <div className="column column-state">
          <div className="state state-wrapper">
            <div className="state_flex state_margin">
              <div className="stateSvg stateSvg-national">
                <Svg statesvg="US" />
              </div>
              <div className="cell cell-national">National</div>
            </div>
          </div>
        </div>
        <div className="column-candidate">
          <div className="row row-wrap">
            {results.candidates?.slice(0, 3).map((candidate) => {
              return (
                <CandidateDelegateCell
                  {...candidate}
                  key={candidate.candidate_id}
                />
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

const CandidateDelegateCell = ({
  candidate_name,
  candidate_id,
  delegates_won,
}) => {
  const has_photo = THOSE_WHOMST_HAVE_PICS.includes(parseInt(candidate_id))
  const photo = has_photo ? (
    // @todo Legacy scheme: raw candidate_id path, no candidateImgSrc helper, no
    // cache-buster, no election namespacing. A future namespaced presidential
    // primary would need candidateImgSrc(candidate_id, date). See RaceFull's
    // getCandidateImage for the namespaced pattern.
    <img
      src={`/data/imgs/candidates/${candidate_id}.jpg`}
      height="64"
      width="64"
      alt={candidate_name}
      onError={useDefaultImg}
    />
  ) : (
    <img
      src={DEFAULT_CANDIDATE_IMAGE}
      height="64"
      width="64"
      alt={candidate_name}
    />
  )

  return (
    <div className="cell cell-candidate">
      <div className="cell_icon">{photo}</div>
      <div className="cell_column">
        <div className="cell_row">
          <div className="cell_name">{candidate_name}</div>
        </div>
        <div className="cell_row">
          <div className="cell_delegates">
            {delegates_won.toLocaleString('en-US')}
          </div>
        </div>
      </div>
      <Sprite />
    </div>
  )
}

PresidentialPrimaryNational.propTypes = {
  url: PropTypes.string.isRequired,
  party: PropTypes.string,
  interval: PropTypes.number,
}

export default PresidentialPrimaryNational
